export const disabledFeatureData = [
  { title: "California, US", value: "25%" },
  { title: "New York, US", value: "15%" },
  { title: "Texas, US", value: "5%" },
];
